import css from '@shared/ui/line-separator/styles/LineSeparator.module.css';
import cn from 'classnames';
import React from 'react';

interface ISeparator {
  className?: string;
}

const LineSeparator: React.FC<ISeparator> = ({ className }): JSX.Element => {
  return <div className={cn(css.lineSeparator, className ? className : '')} />;
};

export default LineSeparator;
